<!-- 不合格报损数据选择模板 -->
<template>
	<el-dialog  title="选择报损数据"  :visible.sync="dialogVisible" top="2rem"   width="90%" :append-to-body="true" center>
		<subComponents @selectDataAction="selectDataAction" ref="showSelectData"></subComponents>
		<div class='components_content_box'>
			<div class="page_content_top">
				<div class="page_content_top_line">
					<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[1]" size="mini">
						<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[1].jurconfigform" :key="formOneKey">
							<el-input v-if="formOneValue.entityField == 'bgmId'" @focus="$refs['showSelectData'].openBox('businessGoodsList','bgmId','bgmId')"
								v-model.trim="getRequestData.bgmName" clearable  :maxlength="$store.state.inputLength">
							</el-input>
							<el-date-picker v-else-if="formOneValue.entityField == 'start'" v-model="getRequestData[formOneValue.entityField]" type="date"  
								placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
							</el-date-picker>
							<el-date-picker v-else-if="formOneValue.entityField == 'end'" v-model="getRequestData[formOneValue.entityField]" type="date"
								placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
							</el-date-picker>
							<el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" size="mini" :maxlength="$store.state.inputLength"></el-input>
						</el-form-item>
					
						<el-form-item>
							<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
						</el-form-item>
						
					</el-form>
				</div>
			</div>
			<div class="page_content_center">
				<el-table  v-if="pageShowData[0]" stripe :data="returnData.list"  border @row-dblclick="selectData"  height="450px" border  style="width: 100%" highlight-current-row>
					<el-table-column
						v-if="tableValye.isShow==1"
						v-for="(tableValye,tableKey) in pageShowData[0].jurconfigtable" 
						:key="tableKey" 
						:prop="tableValye.entityField"  
						:label="tableValye.showField">
						<template  slot-scope="scope">
							<div v-if="tableValye.entityField == 'lumState'">
								未提取
							</div>
							<div v-else-if="tableValye.entityField == 'lumDate'">
								{{$common.getLocalTime(scope.row[tableValye.entityField])}}
							</div>
							<div v-else>
								{{scope.row[tableValye.entityField]}}
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="page_content_bottom">
				<el-pagination
					background
					@size-change="setDataPageSize"
					@current-change="setDataPageNumber"
					:current-page="getRequestData.page"
					:page-sizes="[30,50,100,500]"
					:page-size="30"
					layout="total, sizes, prev, pager, next, jumper"
					:total="returnData.total">
				</el-pagination>
			</div>
		</div>
	</el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'unqualifiedDamageTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				bgmId:'',
				bgmName:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			pageShowData:[],
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		'getRequestData.bgmName':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.getRequestData.bgmId = ''
				}
			},
			deep:true,
		}
	},
	//方法集合
	methods: {
		selectDataAction(selectedData={},name,value){
			switch(name){
				case 'bgmId':
					this.getRequestData.bgmId = selectedData.bgmId
					this.getRequestData.bgmName = selectedData.bgmName
				break;
				
				default:
					this.getRequestData[name] = value
			}
		},
		
		openBox(){
			this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
		},
		selectData(row, column, event){
			this.dialogVisible = false
			this.$emit('selectDataAction',row);
		},
		async getPageInfo(){
			var pathId = parent.getMenuInfo('/unqualifiedDamage')
			let responseData =  await this.$http.pageFormText({ids:[pathId.jurId]})
			if(responseData.status == 200){
				this.pageShowData = responseData.result
				console.log(this.pageShowData)
			
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getUnqualifiedDamageNot(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag{
	margin-right: 1rem;
}
.el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
}
</style>
